export default "__VITE_ASSET__CebrCbPN__"